import { useState } from 'react'
import { NaverLoginButton } from './NaverLoginButton'
import { KakaoLoginButton } from './KakaoLoginButton'
import { AppleLoginButton } from './AppleLoginButton'
import { authApi } from '@/api/auth'
import { useAuthStore } from '@/store/authStore'
import { getApiErrorCode, handleApiError } from '@/api/client'

interface SocialLoginGroupProps {
  onSuccess: () => void
}

export function SocialLoginGroup({ onSuccess }: SocialLoginGroupProps) {
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const login = useAuthStore((s) => s.login)

  const handleSocialLogin = async (socialToken: string, socialType: string, socialCode?: string) => {
    setError('')
    setLoading(true)
    try {
      const response = await authApi.socialLogin(socialToken, socialType, socialCode)
      login(response)
      onSuccess()
    } catch (err) {
      const code = getApiErrorCode(err)
      if (code === 'SOCIAL_NOT_LINKED') {
        setError('깨봉 온라인 계정에 연동되지 않은 소셜 계정입니다. 이메일/비밀번호로 로그인하거나, 깨봉 온라인(www.quebon.tv)에서 계정 연동 후 이용해주세요.')
      } else if (code === 'ACCOUNT_NOT_FOUND') {
        setError('깨봉 온라인에 가입되지 않은 계정입니다. 깨봉 온라인(www.quebon.tv)에서 가입 후 이용해주세요.')
      } else {
        setError(handleApiError(err))
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="space-y-3">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="bg-white px-2 text-gray-500">간편 로그인</span>
        </div>
      </div>

      {loading && (
        <p className="text-sm text-center text-gray-500">로그인 처리 중...</p>
      )}

      {error && (
        <p className="text-sm text-center text-red-500">{error}</p>
      )}

      <div className="space-y-2">
        <KakaoLoginButton
          onToken={(token) => handleSocialLogin(token, 'KAKAO')}
        />
        <NaverLoginButton
          onToken={(token) => handleSocialLogin(token, 'NAVER')}
        />
        <AppleLoginButton
          onToken={(token, code) => handleSocialLogin(token, 'APPLE', code)}
        />
      </div>
    </div>
  )
}
